<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card>
        <b-tabs v-model="tabIndex" ref="tabs_mov_ext" pills>
          <b-tab lazy >
            <template #title>
              <feather-icon icon="ClipboardIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Formulario</span>
            </template>
            <formulario class="mt-2 pt-75" />
          </b-tab>

          <!-- Tab: Information -->
          <!-- <b-tab>
            <template #title>
              <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Detalle</span>
            </template>
            <detalle />
          </b-tab> -->

          <b-tab lazy>
            <template #title>
              <feather-icon icon="LogOutIcon" size="16" class="mr-0 mr-sm-50" />
              <span class="d-none d-sm-inline">Movimientos</span>
            </template>
            <movimientos />
            <!-- <user-edit-tab-information class="mt-2 pt-75" /> -->
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import formulario from './salida-formulario.vue'
import detalle from './salida-detalle.vue'
import movimientos from './salida-movimientos.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      tabIndex: 0
    }
  },
  components:{
    formulario,
    detalle,
    movimientos
  },
  mounted(){
    console.log('this.$store.state.back.routeMovEx',this.$store.state.back.routeMovEx)
    this.tabIndex = this.$store.state.back.indexTabME
    this.$refs.tabs_mov_ext.currentTab = this.tabIndex
    this.$router.beforeEach((to, _, next) => {
      if (to.name != 'detalle-mov-ext' && to.name != 'editar-mov-ext' && to.name != 'stock-salida') {
        this.$store.commit('back/setIndexTabME', 0)
      }
      return next()
    })
  },
}
</script>

<style></style>
